import { pxToRem } from '../../../../utils';
var sizeToPxValue = {
  smallest: 20,
  smaller: 24,
  small: 28,
  medium: 32,
  large: 44,
  larger: 64,
  largest: 96
};
export var avatarStyles = {
  root: function root(_ref) {
    var size = _ref.props.size;
    var sizeInRem = pxToRem(sizeToPxValue[size]);
    return {
      position: 'relative',
      backgroundColor: 'inherit',
      display: 'inline-block',
      verticalAlign: 'middle',
      height: sizeInRem,
      width: sizeInRem
    };
  }
};
//# sourceMappingURL=avatarStyles.js.map
